// extracted by mini-css-extract-plugin
module.exports = {"tools":"SectionSimilar_tools__rkRCZ","btnWrap":"SectionSimilar_btnWrap__wJtpW","btn":"SectionSimilar_btn__Q11Qn"};